/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendConfiguration } from './BackendConfiguration';
import {
    BackendConfigurationFromJSON,
    BackendConfigurationFromJSONTyped,
    BackendConfigurationToJSON,
} from './BackendConfiguration';
import type { TenantModules } from './TenantModules';
import {
    TenantModulesFromJSON,
    TenantModulesFromJSONTyped,
    TenantModulesToJSON,
} from './TenantModules';

/**
 * 
 * @export
 * @interface Tenant
 */
export interface Tenant {
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name: string;
    /**
     * 
     * @type {Array<BackendConfiguration>}
     * @memberof Tenant
     */
    configurations?: Array<BackendConfiguration>;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    company_website: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    name_short: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    default_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    ceo_name: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    support_email: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    info_email: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    dev_email?: string;
    /**
     * Email addresses that receive the daily/weekly statistics digest and the monthly management ratings report. When absent or empty, no statistics emails are compiled or sent for this tenant.
     * @type {Array<string>}
     * @memberof Tenant
     */
    stats_email_recipients?: Array<string>;
    /**
     * Enables the pay-per-use conversion flow: after a first-time pay-per-use patient finishes a paid visit, a follow-up notification (1h) and a membership promo-code email (4h) are scheduled. Off when absent.
     * @type {boolean}
     * @memberof Tenant
     */
    ppu_promo_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    app_subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    portal_subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof Tenant
     */
    default_clinic?: string;
    /**
     * Tenant-wide default cancellation/credit window (hours). Applies when a concern sets no refund_window_hours override. Clamped 0..168. If unset, appointments with no concern override are NOT eligible for credit.
     * @type {number}
     * @memberof Tenant
     */
    default_refund_window_hours?: number;
    /**
     * 
     * @type {TenantModules}
     * @memberof Tenant
     */
    modules?: TenantModules;
}

/**
 * Check if a given object implements the Tenant interface.
 */
export function instanceOfTenant(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "company_website" in value;
    isInstance = isInstance && "name_short" in value;
    isInstance = isInstance && "ceo_name" in value;
    isInstance = isInstance && "support_email" in value;
    isInstance = isInstance && "info_email" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "app_subdomain" in value;
    isInstance = isInstance && "portal_subdomain" in value;

    return isInstance;
}

export function TenantFromJSON(json: any): Tenant {
    return TenantFromJSONTyped(json, false);
}

export function TenantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tenant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'configurations': !exists(json, 'configurations') ? undefined : ((json['configurations'] as Array<any>).map(BackendConfigurationFromJSON)),
        'company_website': json['company_website'],
        'name_short': json['name_short'],
        'default_phone': !exists(json, 'default_phone') ? undefined : json['default_phone'],
        'ceo_name': json['ceo_name'],
        'support_email': json['support_email'],
        'info_email': json['info_email'],
        'dev_email': !exists(json, 'dev_email') ? undefined : json['dev_email'],
        'stats_email_recipients': !exists(json, 'stats_email_recipients') ? undefined : json['stats_email_recipients'],
        'ppu_promo_enabled': !exists(json, 'ppu_promo_enabled') ? undefined : json['ppu_promo_enabled'],
        'domain': json['domain'],
        'app_subdomain': json['app_subdomain'],
        'portal_subdomain': json['portal_subdomain'],
        'default_clinic': !exists(json, 'default_clinic') ? undefined : json['default_clinic'],
        'default_refund_window_hours': !exists(json, 'default_refund_window_hours') ? undefined : json['default_refund_window_hours'],
        'modules': !exists(json, 'modules') ? undefined : TenantModulesFromJSON(json['modules']),
    };
}

export function TenantToJSON(value?: Tenant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'configurations': value.configurations === undefined ? undefined : ((value.configurations as Array<any>).map(BackendConfigurationToJSON)),
        'company_website': value.company_website,
        'name_short': value.name_short,
        'default_phone': value.default_phone,
        'ceo_name': value.ceo_name,
        'support_email': value.support_email,
        'info_email': value.info_email,
        'dev_email': value.dev_email,
        'stats_email_recipients': value.stats_email_recipients,
        'ppu_promo_enabled': value.ppu_promo_enabled,
        'domain': value.domain,
        'app_subdomain': value.app_subdomain,
        'portal_subdomain': value.portal_subdomain,
        'default_clinic': value.default_clinic,
        'default_refund_window_hours': value.default_refund_window_hours,
        'modules': TenantModulesToJSON(value.modules),
    };
}

